<template>
	<div class="content">
		<div class="banner wow animate__animated animate__fadeInUp animate__delay-0.3s">
			<img src="../../static/images/products/banner.png" alt="" v-show="currlangs==0">
			<img src="../../static/images/products/eng/1.png" alt="" v-show="currlangs==1">
			<img src="../../static/images/products/eng/1.png" alt="" v-show="currlangs==2">
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	import proNav from './proNav.vue'

	export default {
	  name: 'proNav',
	  components:{
	    proNav
	  },
		data() {
			return {
				currlangs:0, //0中文 1英文 2西班牙语
				langs: 'zh',
			}
		},
		mounted() {
			let _this = this;
			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			if(_this.currlangs == 2) {
				_this.langs = sp;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
			} else {
				_this.langs = zh;
			}
		},
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/products.vue